var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTableData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 50.625H27.5C26.475 50.625 25.625 49.775 25.625 48.75C25.625 47.725 26.475 46.875 27.5 46.875H52.5C53.525 46.875 54.375 47.725 54.375 48.75C54.375 49.775 53.525 50.625 52.5 50.625Z",
    fill: "#0072ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 33.1252H27.5C26.475 33.1252 25.625 32.2752 25.625 31.2502C25.625 30.2252 26.475 29.3752 27.5 29.3752H52.5C53.525 29.3752 54.375 30.2252 54.375 31.2502C54.375 32.2752 53.525 33.1252 52.5 33.1252Z",
    fill: "#0072ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 15.6248H27.5C26.475 15.6248 25.625 14.7748 25.625 13.7498C25.625 12.7248 26.475 11.8748 27.5 11.8748H52.5C53.525 11.8748 54.375 12.7248 54.375 13.7498C54.375 14.7748 53.525 15.6248 52.5 15.6248Z",
    fill: "#0072ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.1247C9.5251 18.1247 9.0501 17.9497 8.6751 17.5747L6.1751 15.0747C5.4501 14.3497 5.4501 13.1497 6.1751 12.4247C6.9001 11.6997 8.1001 11.6997 8.8251 12.4247L10.0001 13.5997L16.1751 7.42467C16.9001 6.69967 18.1001 6.69967 18.8251 7.42467C19.5501 8.14967 19.5501 9.34967 18.8251 10.0747L11.3251 17.5747C10.9501 17.9497 10.4751 18.1247 10.0001 18.1247Z",
    fill: "#0072ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 35.625C9.5251 35.625 9.0501 35.45 8.6751 35.075L6.1751 32.575C5.4501 31.85 5.4501 30.65 6.1751 29.925C6.9001 29.2 8.1001 29.2 8.8251 29.925L10.0001 31.1L16.1751 24.925C16.9001 24.2 18.1001 24.2 18.8251 24.925C19.5501 25.65 19.5501 26.85 18.8251 27.575L11.3251 35.075C10.9501 35.45 10.4751 35.625 10.0001 35.625Z",
    fill: "#0072ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 53.1248C9.5251 53.1248 9.0501 52.9498 8.6751 52.5748L6.1751 50.0748C5.4501 49.3498 5.4501 48.1498 6.1751 47.4248C6.9001 46.6998 8.1001 46.6998 8.8251 47.4248L10.0001 48.5998L16.1751 42.4248C16.9001 41.6998 18.1001 41.6998 18.8251 42.4248C19.5501 43.1498 19.5501 44.3498 18.8251 45.0748L11.3251 52.5748C10.9501 52.9498 10.4751 53.1248 10.0001 53.1248Z",
    fill: "#0072ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTableData);
export default __webpack_public_path__ + "static/media/noTableData.5416d5755d38657a4754719b1f04857e.svg";
export { ForwardRef as ReactComponent };